export default class Tabs {
    constructor(tabGroup) {
        this.tabContents = tabGroup.querySelectorAll('.tab-content');
        this.tabLinks = tabGroup.querySelectorAll('.tab-link');
        this.init();
    }
    init() {
        const self = this;
        self.tabLinks.forEach((button) => {
            button.addEventListener('click', (e) => {
                const panelId = button.getAttribute('id');
                this.toggleTab(panelId);
            });
        });
    }
    toggleTab(panelId) {
        this.tabContents.forEach((tabContent) => {
            tabContent.classList.remove('open');
            if (tabContent.getAttribute('data-tab-id') === panelId) {
                tabContent.classList.add('open');
            }
        });
    }
}
